<div class="choose-program-container">
    <div class="choose-program-content">
        <div class="program-detail-container">
            <div class="detail-title">{{landingCMSData?.whyToChooseProgramTitle}}</div>
            <div class="detail-subtitle">{{landingCMSData?.whyToChooseProgramDesc}}</div>
        </div>

        <div class="program-card-container">
            <div *ngFor="let card of cardData" class="program-card">
                <div class="program-card-image-container">
                    <img [src]="'https:' + card.fields.cardImage.fields.file.url" alt="Card Image" class="program-card-image">
                </div>
                <div class="program-card-body">
                    <div class="program-card-title">{{ card.fields.cardTitle }}</div>
                    <div class="program-card-description">{{ card.fields.cardDesc }}</div>
                </div>
            </div>
        </div>
    </div>
</div>